import Vue from 'vue'
import Bugsnag from '@bugsnag/js'
import BugsnagPluginVue from '@bugsnag/plugin-vue'

if (process.env.NODE_ENV === 'production') {
  Bugsnag.start({
    apiKey: 'bfda0ffc9070dfaab7004ccc31d04514',
    plugins: [new BugsnagPluginVue()],
  })

  const bugsnagVue = Bugsnag.getPlugin('vue')
  bugsnagVue.installVueErrorHandler(Vue)
}
